// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../index.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
:root {
  --tile-bg: #ffffff;
  --tile-fg: #000000;
  --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  --background-blur: 7.76px;
}

[data-theme=light] {
  --tile-bg: #aaaaaa;
  --tile-fg: #000000;
  --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  --tile-bg-blur: rgba(0, 0, 0, 0.10);
}

[data-theme=dark] {
  --tile-bg: #666666;
  --tile-fg: #ffffff;
  --tile-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
  --tile-bg-blur: rgba(0, 0, 0, 0.29);
}

.debug {
  border: 1px solid red;
  background-color: aqua;
}

.Tile, .ContentTile {
  background-color: var(--tile-bg);
  opacity: 1;
  border-radius: 20px;
  height: 100px;
  margin: 5px;
  width: 100px;
  transition: transform var(--transition-time) ease;
  z-index: 1;
  backdrop-filter: var(--background-blur);
  background: var(--tile-bg-blur);
}

.ContentTile {
  background: var(--color-bg);
  box-shadow: none;
  color: var(--color-fg);
  margin: 0 !important;
  position: relative;
  border: 1px solid var(--border-color);
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ContentTile h1 {
  width: 70%;
  text-align: center;
}
.ContentTile h1,
.ContentTile span {
  display: inline;
  flex-direction: row;
  justify-content: space-around;
  font-family: "Montserrat", sans-serif;
}
@media (max-width: 767px) {
  .ContentTile h1,
  .ContentTile span {
    font-size: 2rem;
    line-height: 2.5rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile h1,
  .ContentTile span {
    font-size: 2.5rem;
    line-height: 3rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .ContentTile h1,
  .ContentTile span {
    font-size: 3rem;
    line-height: 3.5rem;
  }
}
.ContentTile h2 {
  font-family: "Montserrat", sans-serif;
  text-align: center;
  width: 80%;
}
@media (max-width: 767px) {
  .ContentTile h2 {
    font-size: 1rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile h2 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .ContentTile h2 {
    font-size: 2.25rem;
    line-height: 2.75rem;
  }
}
.ContentTile h3 {
  font-family: "Montserrat", sans-serif;
  font-size: 1.2rem;
}
.ContentTile hr {
  width: 70%;
  height: 1px;
  background-color: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}
.ContentTile em,
.ContentTile em * {
  color: #830C00;
  font-style: normal;
}
.ContentTile p {
  display: block;
  text-align: center;
  width: 80%;
  font-size: 1.25rem;
}
@media (max-width: 767px) {
  .ContentTile p {
    font-size: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile p {
    font-size: 1.1rem;
  }
}
.ContentTile ul {
  margin: 0 1rem;
}
.ContentTile ul li {
  margin: 1rem 0;
  font-size: 1.5rem;
  line-height: 2rem;
}
@media (max-width: 767px) {
  .ContentTile ul li {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
@media (max-width: 767px) {
  .ContentTile ul {
    line-height: 1.2rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile ul {
    line-height: 1.3rem;
  }
}
@media (min-width: 1025px) and (max-width: 1439px) {
  .ContentTile ul {
    line-height: 1.5rem;
  }
}
.ContentTile section {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 1rem;
}
@media (max-width: 767px) {
  .ContentTile section {
    flex-direction: column;
  }
}
.ContentTile small {
  font-size: 0.8rem;
  color: var(--color-fg-opacity);
}
.ContentTile video {
  object-fit: cover;
}
.ContentTile a {
  text-decoration: none;
  color: var(--color-fg);
}
.ContentTile a.customButton {
  margin: 0.5rem;
}
.ContentTile a:hover {
  color: var(--color-hover);
}
.ContentTile button {
  margin: 0.5rem;
}
.ContentTile form {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  font-size: 0.5rem;
  color: var(--color-fg);
}
@media (max-width: 767px) {
  .ContentTile form {
    width: 85%;
    font-size: 0.3rem;
    gap: 0.2rem;
  }
}
.ContentTile form .samerow {
  display: flex;
  gap: 1rem;
}
.ContentTile form button {
  background-color: var(--button-bg);
  color: var(--button-fg);
  border-radius: 25px;
  border: 1px solid var(--button-border-color);
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  font-family: "Signika Negative", sans-serif, Arial;
  font-size: 1rem !important;
}
.ContentTile form textarea {
  text-align: left;
  padding: 0.5rem;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background-color: transparent;
  color: var(--color-fg);
  font-size: 2rem;
  width: 80vw;
  font-family: "Montserrat", sans-serif;
  max-width: 80vw;
  min-width: 80vw;
  min-height: fit-content;
  max-height: 30vh;
}
@media (max-width: 767px) {
  .ContentTile form textarea {
    font-size: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile form textarea {
    font-size: 1.5rem;
  }
}
.ContentTile form select {
  padding: 0.5rem;
  border-radius: 10px;
  border: 1px solid var(--border-color);
  background-color: var(--color-bg-opacity);
  color: var(--color-fg);
  font-size: 2rem;
  width: 80vw;
  font-family: "Montserrat", sans-serif;
}
@media (max-width: 767px) {
  .ContentTile form select {
    font-size: 1rem;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .ContentTile form select {
    font-size: 1.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/Tile.scss","webpack://./src/components/ContentTile.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mCAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,kBAAA;EACA,+CAAA;EACA,mCAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,gCAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,iDAAA;EACA,UAAA;EACA,uCAAA;EACA,+BAAA;ACCJ;;AAnCA;EAEI,2BAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAqCJ;AAnCI;EACI,UAAA;EACA,kBAAA;AAqCR;AAlCI;;EAEI,eAAA;EACA,mBAAA;EACA,6BAAA;EACA,qCAAA;AAoCR;AF3DE;EEkBE;;IAQQ,eAAA;IACA,mBAAA;EAsCV;AACF;AF3DE;EEWE;;IAaQ,iBAAA;IACA,iBAAA;EAwCV;AACF;AF3DE;EEIE;;IAkBQ,eAAA;IACA,mBAAA;EA0CV;AACF;AAvCI;EACI,qCAAA;EACA,kBAAA;EACA,UAAA;AAyCR;AFrFE;EEyCE;IAMQ,eAAA;IACA,oBAAA;EA0CV;AACF;AFpFE;EEkCE;IAWQ,iBAAA;IACA,iBAAA;EA2CV;AACF;AFnFE;EE2BE;IAgBQ,kBAAA;IACA,oBAAA;EA4CV;AACF;AAxCI;EACI,qCAAA;EACA,iBAAA;AA0CR;AAvCI;EACI,UAAA;EACA,WAAA;EACA,sBAAA;EACA,2CAAA;AAyCR;AAtCI;;EAEI,cAAA;EACA,kBAAA;AAwCR;AArCI;EACI,cAAA;EACA,kBAAA;EACA,UAAA;EAUA,kBAAA;AA8BR;AF5HE;EEiFE;IAMQ,eAAA;EAyCV;AACF;AF1HE;EE0EE;IAUQ,iBAAA;EA0CV;AACF;AArCI;EACI,cAAA;AAuCR;AArCQ;EACI,cAAA;EAEA,iBAAA;EACA,iBAAA;AAsCZ;AF9IE;EEoGM;IAOQ,eAAA;IACA,mBAAA;EAuCd;AACF;AFpJE;EEiGE;IAgBQ,mBAAA;EAuCV;AACF;AFlJE;EE0FE;IAoBQ,mBAAA;EAwCV;AACF;AFhJE;EEmFE;IAwBQ,mBAAA;EAyCV;AACF;AAtCI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;AAwCR;AFzKE;EE6HE;IAOQ,sBAAA;EAyCV;AACF;AAtCI;EACI,iBAAA;EACA,8BAAA;AAwCR;AArCI;EACI,iBAAA;AAuCR;AApCI;EACI,qBAAA;EACA,sBAAA;AAsCR;AApCQ;EACI,cAAA;AAsCZ;AAlCI;EACI,yBAAA;AAoCR;AAjCI;EACI,cAAA;AAmCR;AAhCI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,sBAAA;AAkCR;AF5ME;EEkKE;IAWQ,UAAA;IACA,iBAAA;IACA,WAAA;EAmCV;AACF;AAjCQ;EACI,aAAA;EACA,SAAA;AAmCZ;AAhCQ;EACI,kCAAA;EACA,uBAAA;EACA,mBAAA;EACA,4CAAA;EACA,sBAAA;EACA,eAAA;EACA,kDAAA;EACA,0BAAA;AAkCZ;AA/BQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,6BAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;EASA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AAyBZ;AFhPE;EEkMM;IAYQ,eAAA;EAsCd;AACF;AF9OE;EE2LM;IAgBQ,iBAAA;EAuCd;AACF;AAhCQ;EACI,eAAA;EACA,mBAAA;EACA,qCAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,qCAAA;AAkCZ;AFpQE;EE0NM;IAWQ,eAAA;EAmCd;AACF;AFlQE;EEmNM;IAcQ,iBAAA;EAqCd;AACF","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@import url('../index.scss');\n\n:root { \n    --tile-bg: #ffffff;\n    --tile-fg: #000000;\n    --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n    --background-blur: 7.76px;\n}\n\n[data-theme=\"light\"] {\n    --tile-bg: #aaaaaa;\n    --tile-fg: #000000;\n    --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n    --tile-bg-blur: rgba(0, 0, 0, 0.10);\n}  \n\n[data-theme=\"dark\"] {\n    --tile-bg: #666666;\n    --tile-fg: #ffffff;\n    --tile-shadow: 0 0 5px rgba(255, 255, 255, 0.3);\n    --tile-bg-blur: rgba(0, 0, 0, 0.29);\n}  \n\n.debug {\n    border: 1px solid red;\n    background-color: aqua;\n}\n\n.Tile {\n    background-color: var(--tile-bg);\n    opacity: 1;\n    border-radius: 20px;\n    height: 100px;\n    margin: 5px;\n    width: 100px;\n    transition: transform var(--transition-time) ease;\n    z-index: 1;\n    backdrop-filter: var(--background-blur);\n    background: var(--tile-bg-blur);\n}","@use '../styles';\n\n@use \"Tile.scss\";\n\n.ContentTile {\n    @extend .Tile;\n    background: var(--color-bg);\n    box-shadow: none;\n    color: var(--color-fg);\n    margin: 0!important;\n    position: relative;\n    border: 1px solid var(--border-color);\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    h1 {\n        width: 70%;\n        text-align: center;\n    }\n\n    h1,\n    span {\n        display: inline;\n        flex-direction: row;\n        justify-content: space-around;\n        font-family: \"Montserrat\", sans-serif;\n\n        @include styles.mobile {\n            font-size: 2rem;\n            line-height: 2.5rem;\n        }\n\n        @include styles.tablet {\n            font-size: 2.5rem;\n            line-height: 3rem;\n        }\n\n        @include styles.desktop {\n            font-size: 3rem;\n            line-height: 3.5rem;\n        }\n    }\n\n    h2 {\n        font-family: \"Montserrat\", sans-serif;\n        text-align: center;\n        width: 80%;\n\n        @include styles.mobile {\n            font-size: 1rem;\n            line-height: 1.25rem;\n        }\n\n        @include styles.tablet {\n            font-size: 1.5rem;\n            line-height: 2rem;\n        }\n\n        @include styles.desktop {\n            font-size: 2.25rem;\n            line-height: 2.75rem;\n        }\n\n    }\n\n    h3 {\n        font-family: \"Montserrat\", sans-serif;\n        font-size: 1.2rem;\n    }\n\n    hr {\n        width: 70%;\n        height: 1px;\n        background-color: none;\n        border-bottom: 1px solid rgba(0, 0, 0, 0.20);\n    }\n\n    em,\n    em * {\n        color: #830C00;\n        font-style: normal;\n    }\n\n    p {\n        display: block;\n        text-align: center;\n        width: 80%;\n\n        @include styles.mobile {\n            font-size: 1rem;\n        }\n\n        @include styles.tablet {\n            font-size: 1.1rem;\n        }\n\n        font-size: 1.25rem;\n    }\n\n    ul {\n        margin: 0 1rem;\n        \n        li {\n            margin: 1rem 0;\n\n            font-size: 1.5rem;\n            line-height: 2rem;\n\n            @include styles.mobile {\n                font-size: 1rem;\n                line-height: 1.5rem;\n            }\n        }\n        \n        @include styles.mobile {\n            line-height: 1.2rem;\n        }\n\n        @include styles.tablet {\n            line-height: 1.3rem;\n        }\n\n        @include styles.desktop {\n            line-height: 1.5rem;\n        }\n    }\n\n    section {\n        display: flex;\n        flex-direction: row;\n        gap: 1rem;\n        padding: 1rem;\n\n        @include styles.mobile {\n            flex-direction: column;\n        }\n    }\n\n    small {\n        font-size: 0.8rem;\n        color: var(--color-fg-opacity);\n    }\n\n    video {\n        object-fit: cover;\n    }\n\n    a {\n        text-decoration: none;\n        color: var(--color-fg);\n        \n        &.customButton  {\n            margin: 0.5rem;\n        }\n    }\n\n    a:hover {\n        color: var(--color-hover);\n    }\n\n    button {\n        margin: 0.5rem;\n    }\n\n    form {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        gap: 1rem;\n        font-size: 0.5rem;\n        color: var(--color-fg);\n\n        @include styles.mobile {\n            width: 85%;\n            font-size: 0.3rem;\n            gap: 0.2rem;\n        }\n\n        .samerow {\n            display: flex;\n            gap: 1rem; // Adjust the gap as needed\n        }        \n\n        button {\n            background-color: var(--button-bg);\n            color: var(--button-fg);\n            border-radius: 25px;\n            border: 1px solid var(--button-border-color);\n            padding: .5rem 1.5rem;\n            cursor: pointer;\n            font-family: \"Signika Negative\", sans-serif, Arial;\n            font-size: 1rem!important;\n        }        \n\n        textarea {\n            text-align: left;\n            padding: 0.5rem;\n            border-radius: 10px;\n            border: 1px solid var(--border-color);\n            background-color: transparent;\n            color: var(--color-fg);\n            font-size: 2rem;\n            width: 80vw;\n            font-family: \"Montserrat\", sans-serif;\n\n            @include styles.mobile {\n                font-size: 1rem;\n            }\n\n            @include styles.tablet {\n                font-size: 1.5rem;\n            }\n            max-width: 80vw;\n            min-width: 80vw;\n            min-height: fit-content;\n            max-height: 30vh;\n        }\n\n        select {\n            padding: 0.5rem;\n            border-radius: 10px;\n            border: 1px solid var(--border-color);\n            background-color: var(--color-bg-opacity);\n            color: var(--color-fg);\n            font-size: 2rem;\n            width: 80vw;\n            font-family: \"Montserrat\", sans-serif;\n\n            @include styles.mobile {\n                font-size: 1rem;\n            }\n            @include styles.tablet {\n                font-size: 1.5rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
